module.exports = __webpack_public_path__ + "img/mdi-check.04d06825.svg";